<div id="about" class="about-area">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12">
                <div class="about-content ">

                    <div class="description">

                        <div class="license-panel">
                            <h2>Лицензия</h2>
                            <div class="table-wrapper">
                                <table class="license-table">
                                    <tbody>
                                        <tr><td>ОГРН</td><td>1027746001909</td></tr>
                                        <tr><td>Решение о предоставлении</td><td>Приказ от 16.09.2022 № 1511Л</td></tr>
                                        <tr><td>Текущий статус лицензии</td><td>Действует</td></tr>
                                        <tr><td>Полное наименование организации</td><td>Общероссийская общественная организация малого и среднего предпринимательства «ОПОРА РОССИИ»</td></tr>
                                        <tr><td>Наименование органа, выдавшего лицензию</td><td>Департамент образования и науки города Москвы</td></tr>
                                        <tr><td>Срок действия</td><td>Бессрочная</td></tr>
                                        <tr><td>Субъект РФ</td><td>г. Москва</td></tr>
                                        <tr><td>Сокращенное наименование</td><td>«ОПОРА РОССИИ»</td></tr>
                                        <tr><td>ИНН</td><td>7704247293</td></tr>
                                        <tr><td>КПП</td><td>770701001</td></tr>
                                        <tr><td>Регистрационный номер</td><td>Л035-01298-77/00616624</td></tr>
                                        <tr><td>Место нахождения</td><td>127473, город Москва, пер. 2-й Самотёчный, д. 7</td></tr>
                                        <tr><td>Дата внесения изменений</td><td>16.09.2022</td></tr>
                                    </tbody>
                                </table>
                            </div>

                            <p>
                                <a class="license-button" href="https://opora.ru/about/ustavnye-dokumenty/" target="_blank">
                                    Уставные документы
                                </a>
                            </p>



                            <div class="activity-panel">
                                <h2>Сведения о лицензируемом виде деятельности</h2>

                                <div class="table-wrapper">
                                    <table class="activity-table">
                                        <tbody>
                                            <tr>
                                                <td><strong>Организация</strong></td>
                                                <td><strong>Статус</strong></td>
                                                <td><strong>Приказ (распоряжение)</strong></td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Общероссийская общественная организация<br>
                                                    малого и среднего предпринимательства «ОПОРА РОССИИ»
                                                </td>
                                                <td>Действует</td>
                                                <td>Приказ от 16.09.2022 № 1511Л</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>



                            <section class="documents-section">
                                <div class="cont">
                                    <ul class="document-list">
                                        <li>
                                            <a href="https://opora.ru/site/assets/files/71594/polozhenie_o_distantsionnoy_forme_obucheniya_sayt.pdf" target="_blank">
                                                <span class="icon">
                                                    <i class="fas fa-file-pen"></i>
                                                </span>
                                                Положение о дистанционной форме обучения
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://opora.ru/site/assets/files/71594/polozhenie_o_poryadke_okazaniya_platnykh_obrazovatelnykh_uslug_sayt.pdf" target="_blank">
                                                <span class="icon">
                                                    <i class="fas fa-file-pen"></i>
                                                </span>
                                                Положение о порядке оказания платных образовательных услуг
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://opora.ru/site/assets/files/71594/polozhenie_o_tekhnicheskom_obsluzhivanii_uchebnogo_razdela_na_sayte_say.pdf" target="_blank">
                                                <span class="icon">
                                                    <i class="fas fa-file-pen"></i>
                                                </span>
                                                Положение о техническом обслуживании учебного раздела на сайте
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://opora.ru/site/assets/files/71594/polozhenie_o_rezhime_zanyatiy_obuchayushchikhsya_sayt.pdf" target="_blank">
                                                <span class="icon">
                                                    <i class="fas fa-file-pen"></i>
                                                </span>
                                                Положение о режиме занятий обучающихся
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://opora.ru/site/assets/files/71594/polozhenie_ob_itogovoy_attestatsii_obuchayushchikhsya_sayt.pdf" target="_blank">
                                                <span class="icon">
                                                    <i class="fas fa-file-pen"></i>
                                                </span>
                                                Положение об итоговой аттестации обучающихся
                                            </a>
                                        </li>

                                        <li>
                                            <a href="https://opora.ru/site/assets/files/71594/polozhenie_ob_obrabotke_i_zashchite_personalnykh_dannykh_slushateley_say.pdf" target="_blank">
                                                <span class="icon">
                                                    <i class="fas fa-file-pen"></i>
                                                </span>
                                                Положение об обработке и защите персональных данных слушателей
                                            </a>
                                        </li>

                                        <li>
                                            <a href="https://opora.ru/site/assets/files/71594/polozhenie_ob_oformlenii_vydache_i_khranenii_dokumentov_sayt.pdf" target="_blank">
                                                <span class="icon">
                                                    <i class="fas fa-file-pen"></i>
                                                </span>
                                                Положение об оформлении, выдаче и хранении документов
                                            </a>
                                        </li>

                                        <li>
                                            <a href="https://opora.ru/site/assets/files/71594/polozhenie_o_poryadke_priema_otchisleniya_i_vosstanovleniya_obuchayushchikhs.pdf" target="_blank">
                                                <span class="icon">
                                                    <i class="fas fa-file-pen"></i>
                                                </span>
                                                Положение о порядке приема, отчисления и восстановления обучающихся_сайт
                                            </a>
                                        </li>

                                        <li>
                                            <a href="https://opora.ru/site/assets/files/71594/prikaz_no_1u_ob_ustanovlenii_stoimosti_obucheniya_po_programmam_dpo_na.pdf" target="_blank">
                                                <span class="icon">
                                                    <i class="fas fa-file-pen"></i>
                                                </span>
                                                Приказ № 1У об установлении стоимости обучения по программам ДПО на 2024г._сайт
                                            </a>
                                        </li>

                                        <li>
                                            <a href="https://opora.ru/site/assets/files/71594/prikaz_no_4u_ot_02_09_2024_o_sozdanii_i_sostave_attestatsionnoy_komissii_d.pdf" target="_blank">
                                                <span class="icon">
                                                    <i class="fas fa-file-pen"></i>
                                                </span>
                                                Приказ № 4У от 02.09.2024_ о создании и составе аттестационной комиссии для проведения аттестации по программа ДПО и ДО_сайт
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    </div>

